/* unplugin-vue-components disabled */import { render } from "./external-link.vue?vue&type=template&id=37092e49"
import script from "./external-link.vue?vue&type=script&lang=js"
export * from "./external-link.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/external-link/external-link.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37092e49"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37092e49', __exports__)) {
    api.reload('37092e49', __exports__)
  }
  
  module.hot.accept("./external-link.vue?vue&type=template&id=37092e49", () => {
    api.rerender('37092e49', render)
  })

}


export default __exports__